module.exports = __webpack_public_path__ + "vc.svg?9b9d4796590525ca0d73708919a3f5e2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/vc.svg
// module id = 1412
// module chunks = 27